var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 24,
    viewBox: "0 0 150 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.022 6.96376H47.8821C46.7133 6.96376 46.1308 7.45254 46.1308 8.41229V15.2176C46.1308 16.1774 46.7133 16.6662 47.8821 16.6662H65.0775V19.3377H47.8821C44.8491 19.3377 43.3257 18.0949 43.3257 15.6312V7.99277C43.3257 5.5271 44.8511 4.28635 47.8821 4.28635H65.022V6.96376Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8626 15.6747C90.8626 18.1206 89.3352 19.3435 86.3062 19.3435H73.0828C70.0498 19.3435 68.5264 18.1008 68.5264 15.6371V4.29221H71.3315V15.3541C71.3315 16.2387 71.9159 16.672 73.0847 16.672H86.3062C87.473 16.672 88.0574 16.2387 88.0574 15.3917V4.29221H90.8646L90.8626 15.6747Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M116.602 9.31459C116.611 9.78072 116.493 10.2405 116.26 10.6448C116.028 11.0492 115.69 11.3828 115.283 11.6101C115.721 11.7479 116.104 12.0241 116.372 12.3973C116.64 12.7705 116.78 13.2206 116.77 13.68V15.6371C116.77 18.1008 115.265 19.3435 112.232 19.3435H94.3074V4.29221H112.244C115.164 4.29221 116.614 5.53296 116.614 7.99863L116.602 9.31459ZM97.1085 6.96369V10.5257H112.957C113.086 10.5289 113.215 10.5052 113.335 10.4562C113.455 10.4073 113.564 10.334 113.654 10.241C113.744 10.1481 113.814 10.0375 113.86 9.91619C113.905 9.79488 113.925 9.66551 113.918 9.53622V8.44982C113.918 7.46038 113.428 6.96369 112.222 6.96369H97.1085ZM97.1085 12.928V16.672H111.78C113.155 16.672 113.959 16.3891 113.959 15.2868V13.7928C113.959 13.2862 113.62 12.928 112.969 12.928H97.1085Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M123.01 19.3435H120.205V4.29221H123.01V19.3435Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M141.543 11.2915L150 19.3435H146.101L139.283 12.7954H136.666L129.847 19.3435H125.948L134.405 11.2915L126.608 4.29221H130.524L136.864 10.1813H139.104L145.444 4.29221H149.36L141.543 11.2915Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8026 5.85755L30.6369 0.326599L24.1272 11.5626L30.6805 22.8165L33.8026 17.4617L30.4507 11.6042L33.8026 5.85755Z",
    fill: "#CEFE01"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.2855L3.1657 22.8165L9.67737 11.5805L3.12212 0.326599L0 5.68143L3.35192 11.5389L0 17.2855Z",
    fill: "#CEFE01"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3563 0L20.3293 5.74863L20.3194 5.73478H13.5799L10.4399 0H3.90845L10.4399 11.0995L23.3603 11.1213L29.8026 0H23.3563Z",
    fill: "#CEFE01"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3547 23.1133L13.3818 17.3627L13.3917 17.3785H20.1312L23.2711 23.1133H29.8026L23.2711 12.0118L10.3508 11.992L3.90845 23.1133H10.3547Z",
    fill: "#CEFE01"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.92fc32fb5535a0cbb570aadd843a7505.svg";
export { ForwardRef as ReactComponent };